import styled from 'styled-components';
import { body, poppinsRegularFont } from '../../styles/typography';
import { flex } from '../../styles/layout';
import { media } from '@/styles/responsive';

export const ConfirmBody = styled.div`
  margin-bottom: 24px;
  ${body};
  ${poppinsRegularFont};

  ${media.mobile`
    margin-bottom: 28px;
  `}
`;

export const ConfirmModalButtons = styled.div`
  width: 100%;
  gap: 20px;
  ${flex({ alignItems: 'center', justifyContent: 'flex-end' })};

  ${media.mobile`
    ${flex({ alignItems: 'center', justifyContent: 'center' })};
  `}
`;

export const Hint = styled.div`
  margin-bottom: 8px;
  text-align: left;

  ${media.mobile`
    margin-bottom: 16px;
  `}

  &:last-child {
    margin-bottom: 0;
  }
`;
